import { render, staticRenderFns } from "./UICheckbox.vue?vue&type=template&id=39aceefc&scoped=true&"
import script from "./UICheckbox.vue?vue&type=script&lang=ts&"
export * from "./UICheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./UICheckbox.vue?vue&type=style&index=0&id=39aceefc&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../vue-loader-virtual-c5444c0a66/0/cache/vue-loader-npm-15.9.1-90a0e5830b-a9a3ffbe3c.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aceefc",
  null
  
)

export default component.exports